import React, { useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import moment from "moment";

import styles from "./Invoices.module.scss";
import { getInvoices } from "../../api";
import { TTP_ONBOARDING_URL } from "../../config";
import _ from "../../i18n";
import Invoice from "./Invoice";
import Pagination from "../common/Pagination";
import BackButton from "../common/BackButton";

const LIMIT = 20;

const Invoices = () => {
  const auth = useSelector((state) => state.auth);
  const { token, user } = auth;
  const fiduciary = useSelector((state) => state.folder.fiduciary);
  const language = useSelector((state) => state.params.language);
  const [page, setPage] = useState(1);
  const [year, setYear] = useState(moment().year());
  const [search, setSearch] = useState("");

  const { isLoading, data } = useQuery(
    ["getInvoices", token, fiduciary, year, page],
    async () => {
      if (token && fiduciary) {
        const monthsArray = [];
        for (let i = 1; i <= 12; i++) {
          const formattedMonth = `${year}-${i.toString().padStart(2, "0")}`;
          monthsArray.push(formattedMonth);
        }

        const filters = {
          organization: fiduciary.id,
          user: user.id,
          documentDate: monthsArray,
          page,
          limit: LIMIT,
        };

        try {
          const response = await getInvoices({ token, filters });

          return response.data;
        } catch (e) {
          return null;
        }
      }
    }
  );

  const renderInvoices = () => {
    if (isLoading) {
      return (
        <SkeletonTheme>
          <tr className={`${styles.item} ${styles.fetching}`}>
            <td className={styles.date}>
              <Skeleton />
              <Skeleton width="50%" />
            </td>
            <td className={styles.description}>
              <Skeleton />
              <Skeleton width="50%" />
            </td>
            <td className={styles.paymentMethod}>
              <Skeleton />
            </td>
            <td className={styles.amount}>
              <Skeleton />
            </td>
            <td className={styles.status}>
              <div>
                <Skeleton className={styles.bullet} />
                <Skeleton containerClassName={styles.label} />
              </div>
            </td>
            <td className={styles.action}>
              <Skeleton className={styles.button} />
            </td>
          </tr>
        </SkeletonTheme>
      );
    }

    const showCreditNotes = false;

    const documents = data?.data
      ?.map((order) => {
        if (!order.creditNotes?.length || !showCreditNotes) {
          return [{ order, creditNote: undefined }];
        }

        const mainDocument = { order, creditNote: undefined };
        const creditNoteDocuments = order.creditNotes.map((creditNote) => ({
          order,
          creditNote,
        }));

        return [mainDocument, ...creditNoteDocuments];
      })
      .flat();

    return (
      <>
        {documents?.map(({ order, creditNote }) => (
          <Invoice
            order={order}
            creditNote={creditNote}
            key={`${order.id}—${creditNote?.id ?? "0"}`}
            language={language}
            token={token}
          />
        ))}
      </>
    );
  };

  return (
    <>
      {/* {isLoading && <div className="lmask" />} */}
      <BackButton
        onClick={() =>
          (window.location = `${TTP_ONBOARDING_URL}/subscriptions`)
        }
        // title={"Gérer mes factures"}
      />
      <div className="grid-container">
        <h1 className={styles.pageTitle}>Gérer mes factures</h1>
        <p className={styles.pageHelpTitle}>
          Gérez toutes vos factures liées à United Associates dans cette fenêtre
        </p>

        <div className={styles.tableWrapper}>
          <table className={styles.items}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Mode de paiement</th>
                <th className={styles.amount}>Montant</th>
                <th>Statut</th>
                <th />
              </tr>
            </thead>
            <tbody>{renderInvoices()}</tbody>
          </table>
        </div>
        {data?.nbResult && (
          <>
            <Pagination
              className="pagination-bar"
              currentPage={page}
              totalCount={data.nbResult}
              pageSize={LIMIT}
              onPageChange={(page) => setPage(page)}
            />
          </>
        )}
      </div>
    </>
  );
};

export default Invoices;
